/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsVideoHeroViewProps } from '../../../modules/hosports-video-hero/./hosports-video-hero';
import VideoHero from "./../../../baseComponents/video-hero/./video-hero";

/**
 *
 * Hero component
 * @extends {React.Component<IHosportsVideoHeroViewProps>}
 */
 class HosportsVideoHero extends React.Component<IHosportsVideoHeroViewProps> {

   public render(): JSX.Element {
     const { config } = this.props;
     let icon = config.icon ? config.icon.src : undefined;
     let link = '';
     let linkText = '';
     if(config.link){
       if(config.link.linkText){
         linkText = config.link.linkText
       }
       if(config.link.linkUrl){
         link = config.link.linkUrl.destinationUrl;
       }
     }
     return (
       <VideoHero
         title={config.title}
         subtitle={config.subtitle}
         description={config.description}
         icon={icon}
         preTitle={config.preTitle}
         video={config.video}
         backgroundTint={config.backgroundTint}
         height={config.height}
         textPlacement={config.textPlacement}
         theme={config.theme}
         link={link}
         buttonText={linkText}
         brandedTextImage={config.brandedTextImage}
         brandedTextImageMaxWidth={config.brandedTextImageMaxWidth}
         decorativeText={config.decorativeText}
         quickCompareCategoryId={config.quickCompareCategoryId}
         quickCompareTheme={config.quickCompareTheme}
         year={config.year}
       />
     );
   }
 }

export default HosportsVideoHero;
